export const stringWithComma = (str: string): string => {
  return str.split(' ').join(',')
}
